import { db } from '../../firebase';
import { Author } from '../types/author';
import { collection, getDocs, addDoc, updateDoc, doc, where, query, getDoc } from 'firebase/firestore';
import { parseContent, parseContents } from '../utils';
import { parseAuthor, parseAuthors } from './parser';
import { ProjectErrorType } from '../../utils/errors/types';
import { getProjectErrorFromRawError, isProjectError } from '../../utils/errors';
import { CreateAuthorDto, UpdateAuthorDto } from '../typeDtos/author';

export const getAllAuthors = async (): Promise<Author[]> => {
  try {
    const _query = query(collection(db, 'authors'));
    const rawResult = await getDocs(_query);
    return await parseAuthors(parseContents(rawResult));
  } catch (error) {
    console.log(`[AUTHORS] Error at getAllAuthors`, error);
    return [];
  }
};

export const getAuthorById = async (id: string) => {
  try {
    const _query = await getDoc(doc(db, 'authors', id));
    if (!_query.exists()) {
      console.log('No such document!');
      return undefined;
    }
    const result = await parseAuthor(parseContent(_query));
    const resultError = isProjectError(result);
    if (!resultError) {
      return result as Author;
    }
  } catch (error) {
    console.log(`[AUTHORS] Error at getAuthorsById with id ${id}:`, error);
    return undefined;
  }
};

export const createAuthor = async (
  data: CreateAuthorDto,
): Promise<ProjectErrorType | { success: boolean; id: string }> => {
  try {
    const nowTs = new Date().getTime();
    const _data = {
      ...data,
      createdAt: nowTs,
      updatedAt: nowTs,
    };
    const result = await addDoc(collection(db, 'authors'), _data);
    return { success: true, id: result?.id };
  } catch (e) {
    console.log('[AUTHORS] Error at createAuthor:', e);
    return getProjectErrorFromRawError(e as Error);
  }
};

export const updateAuthor = async (data: UpdateAuthorDto): Promise<ProjectErrorType | { success: boolean }> => {
  try {
    const nowTs = new Date().getTime();
    const _data = { ...data, updatedAt: nowTs };
    const docRef = doc(db, 'authors', _data?.id);
    await updateDoc(docRef, _data);
    return { success: true };
  } catch (e) {
    console.log('[AUTHORS] Error at updateAuthor:', e);
    return getProjectErrorFromRawError(e as Error);
  }
};
